import { colors } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  content: {
    paddingBottom: '5rem',
    maxWidth: '170rem',
    margin: '0 auto',
  },
  dateRange: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  actionHeader: {
    display: 'flex',
    rowGap: '8rem',
    columnGap: '2rem',
    flexWrap: 'wrap',
    marginBottom: '8rem',
    justifyContent: 'center',
    '@media(min-width:1840px)': {
      justifyContent: 'space-between',
    },
  },
  filters: {
    display: 'flex',
    gap: '3rem',
    alignItems: 'center',
  },
  leftFilters: {
    display: 'flex',
    gap: '3rem',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  rightFilters: {
    display: 'flex',
    gap: '3rem',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  // Table
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    maxWidth: '170rem',
    margin: '0 auto',
    boxShadow: boxShadows.dark[4],
    overflow: 'hidden',
  },
  table: {
    width: 'max(100%, 129rem)',
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  headingsRow: {
    borderTop: `0.1rem solid ${colors.neutral[500]}`,
  },
  tableHeading: {
    padding: '1.6rem 0.5rem',
    backgroundColor: TABLE_HEADER_BG_COLOR,
    '&:first-child': {
      paddingLeft: '2.4rem',
      width: '4rem',
    },
    '&:nth-child(2)': {
      paddingRight: '2rem',
      width: '4rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
      width: '5rem',
    },
  },
  emailStatusHeading: {
    width: '5rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
